import React, { Component } from 'react';
import PropTypes from 'prop-types'
import LoaderOverlay from '../../components/LoaderOverlay'
import isURL from 'validator/lib/isURL';
import Fetcher from '../../util/fetcher';

/**
 * Periscope dashboard container
 * Talks to the API to get the URL for a dataset, then proceeds to load this URL in a screen-filling iframe.
 */
class PeriscopeDash extends Component {
  static contextTypes = {
    datasets: PropTypes.object.isRequired,
    firebaseToken: PropTypes.string.isRequired,
    dataset: PropTypes.string.isRequired,
  }

  state = {
    loadingLink: true,
    loadingIframe: true,
    periscopeLink: undefined,
  }

  componentDidMount() {
    this.fetchLink();
  }

  componentDidUpdate() {
    this.fetchLink();
  }

  componentWillUnmount() {
    clearTimeout(this.refreshTimeout);
  }

  regenerateReportUrl = () => {
    // only reload if the tab is active
    requestAnimationFrame(()=> {
      this.fetchLink(true);
    });
  }

  // Fetch a new link every time the dataset or firebase token changes
  fetchLink(force = false) {
    // Only run this function if there is a valid firebaseToken and when the dataset has changed.
    if (
      !this.context.firebaseToken ||
      (
        this.selectedDataset === this.context.dataset &&
        this.firebaseToken === this.context.firebaseToken &&
        !force
      )
    ) {
      return;
    }
    this.selectedDataset = this.context.dataset;
    this.firebaseToken = this.context.firebaseToken;

    clearTimeout(this.refreshTimeout);

    Fetcher.init(this.context.firebaseToken)
      .periscopeGetLink(this.context.dataset)
      .then(({data: link}) => {
        if (!isURL(link)) {
          console.error(`Something strange happened. We were expecting a URL, but received ${link}`);
        }
        // regenerate the report URL every 59 minutes
        this.refreshTimeout = setTimeout(this.regenerateReportUrl, 59 * 60 * 1000);
        this.setState({
          loadingLink: false,
          periscopeLink: link,
        });
      })
      .catch(e => console.error(e));
  }

  handleIframeLoad = () => {
    this.setState({loadingIframe: false});
  }

  render() {
    const styles = {
      iframeContainer: { position: 'absolute', width: '100%', left: 0, height: window.innerHeight-52},
      iframe: { border: 0, width: '100%', height: '100%'},
    }
    const { loadingIframe, loadingLink} = this.state;
    return (
      <div style={styles.iframeContainer}>
        <LoaderOverlay visible={loadingLink || loadingIframe} />
        {!loadingLink &&
          <iframe
            title="periscope-dash"
            style={styles.iframe}
            src={this.state.periscopeLink} 
            onLoad={this.handleIframeLoad}
          />
        }
      </div>
    )
  }
}
export default PeriscopeDash;



// WEBPACK FOOTER //
// ./src/containers/PeriscopeDash/index.jsx